import React, {Component} from 'react'; 
import {   Link } from 'react-router-dom'; 
import { base_url} from '../common/Constants';

class Footer extends Component {

    constructor(){
        super();
        this.state = {
            
        }
    }
    componentDidMount()
    { 

       
    }

      
    render()
    {
        const fb = base_url+'assets/_nuxt/img/fb.7d66205.svg';
        const twitter = base_url+'assets/_nuxt/img/tw.ed30bb1.svg';
        const Instagram = base_url+'assets/_nuxt/img/in.4140e00.svg';
        const tiktok = base_url+'assets/_nuxt/img/tk.5478831.svg';
        const linkedin = base_url+'assets/_nuxt/img/ln.a025388.svg';
        const youtube = base_url+'assets/_nuxt/img/yt.6d040f7.svg';

        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
 
  return (
 
      
         <footer data-v-e8f34808="" style={{overflow:'hidden'}}>
      <div class="top-footer">
       <div class="fc-large">
        <div class="footer-logo" data-aos="fade-in" data-aos-anchor-placement="top" data-aos-delay="200" data-aos-duration="500">
         <img alt="Esco Logo" src={JSON.parse(localStorage.getItem("settings")).site_footer_logo}/>
        </div>
        <div class="footer-address-box" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="400" data-aos-duration="500">
         <div>
             <div dangerouslySetInnerHTML={{ __html: JSON.parse(localStorage.getItem("settings")).site_factory_address }} />  
        
         </div>
         <div class="footer-contacts">
          <div class="fc-lines">
           <div class="fc-number" style={{width: '100px'}}>
            TOLL FREE:
           </div>
           <div class="fc-title">
            {JSON.parse(localStorage.getItem("settings")).site_toll_free_number}
           </div>
          </div>
          <div class="fc-lines">
           <div class="fc-number"  style={{width: '100px'}}>
            TEL:
           </div>
           <div class="fc-title">
            {JSON.parse(localStorage.getItem("settings")).site_factory_number}
           </div>
          </div>
         </div>
         <div class="fc-social">
          <Link to={JSON.parse(localStorage.getItem("settings")).site_facebook} style={{backgroundImage:'url('+fb+')'}}
           aria-label="Facebook" class="fs-fb" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="400" data-aos-duration="250" target="_blank">
          </Link>
          <Link to={JSON.parse(localStorage.getItem("settings")).site_xcom} style={{backgroundImage:'url('+twitter+')'}} aria-label="XCom" class="fs-tw" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="500" data-aos-duration="250" target="_blank">
          </Link>
          <Link to={JSON.parse(localStorage.getItem("settings")).site_instagram} style={{backgroundImage:'url('+Instagram+')'}} aria-label="Instagram" class="fs-in" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="600" data-aos-duration="250" target="_blank">
          </Link>
          <Link to={JSON.parse(localStorage.getItem("settings")).site_linkedin} style={{backgroundImage:'url('+linkedin+')'}} aria-label="Linkedin" class="fs-ln" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="700" data-aos-duration="250" target="_blank">
          </Link>
          <Link to={JSON.parse(localStorage.getItem("settings")).site_tiktok} style={{backgroundImage:'url('+tiktok+')'}} aria-label="Tiktok" class="fs-tk" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="800" data-aos-duration="250" target="_blank">
          </Link>
          <Link to={JSON.parse(localStorage.getItem("settings")).site_youtube} style={{backgroundImage:'url('+youtube+')'}} aria-label="Youtube" class="fs-yt" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="900" data-aos-duration="250" target="_blank">
          </Link>
         </div>
        </div>
       </div>
       <div class="fc-small">
        <div class="fcs-title" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="100" data-aos-duration="500">
         QUICK LINKS
        </div>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="200" data-aos-duration="500"  to={base_url+`downloads`}>
         DOWNLOADS
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="300" data-aos-duration="500"  to={base_url+`contact-us`}>
         CONTACTS
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="400" data-aos-duration="500"  to={base_url+`careers`}>
         CAREERS
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="500" data-aos-duration="500"  to={base_url+`news`}>
         NEWS
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="600" data-aos-duration="500"  to={base_url+`abudhabi`}>
         ABU DHABI
        </Link>
       </div>
       <div class="fc-small">
        <div class="fcs-title" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="250" data-aos-duration="500">
         EXPLORE ESCO
        </div>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="350" data-aos-duration="500"  to={base_url+`key-figures`}>
         KEY FIGURES
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="450" data-aos-duration="450"  to={base_url+`why-are-we-different`} >
         WHY ESCO
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="550" data-aos-duration="500" to={base_url+`sustainability`}  >
         SUSTAINABILITY
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="650" data-aos-duration="500"  to={base_url+`stakeholders/partners`}  >
         PARTNERS
        </Link>
        <Link class="fcs-link" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="750" data-aos-duration="500"  to={base_url+`stakeholders/zclients`}  >
         CLIENTS
        </Link>
       </div>
      </div>
      <div class="bottom-footer">
       <div class="copyright" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="750" data-aos-duration="500">
        ALL RIGHTS RESERVED © {JSON.parse(localStorage.getItem("settings")).date}
       </div>
       <div class="legal" data-aos="fade-up" data-aos-anchor-placement="top" data-aos-delay="750" data-aos-duration="500">
        <Link class="first-legal"  to={base_url+`privacy-policy`}  >
         PRIVACY POLICY
        </Link>
        <Link  to={base_url+`cookie-policy`}  >
         COOKIES POLICY
        </Link>
       </div>
      </div>
     </footer>
 )
};
}
export default Footer;